import { useInfiniteQuery } from '@tanstack/react-query'
import { useCallback } from 'react'
import { getFilteredDevices } from '../api/deviceAPI'

const PER_PAGE = 10

export const usePaginatedDevices = (search = '', userId = null, isAdmin = false) => {
    const fetchPage = useCallback(
        async ({ pageParam = 1 }) => {
            const params = {
                page: pageParam,
                per_page: PER_PAGE,
                ...(search ? { 'devices,name_tx': `like:${search}` } : {}),
                ...(!isAdmin && userId ? { 'devices,user_id': userId } : {}),
            }

            const result = await getFilteredDevices(params)
            return {
                current_page: result?.current_page,
                last_page: result?.last_page,
                data: (result?.data || []).map((d) => ({
                    value: d.device_id,
                    label: d.name_tx,
                })),
            }
        },
        [search, userId, isAdmin]
    )

    return useInfiniteQuery({
        queryKey: ['paginated-devices', search, userId, isAdmin],
        queryFn: fetchPage,
        getNextPageParam: (lastPage) => {
            if (lastPage?.current_page < lastPage?.last_page) {
                return lastPage.current_page + 1
            }
        },
        staleTime: 0,
        cacheTime: 0,
        keepPreviousData: false,
    })
}
